module.exports = __webpack_public_path__ + "static/media/Kayley Cox Headshot_1693945675997.b1652798.jpeg";